export function isFullName(name = '') {
  if (!name) {
    return false;
  }

  return name.split(' ').filter(content => content !== '').length > 1;
}
